exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".typography--whiteText--2eeXA{color:#fff;fill:#fff}.typography--boldText--osnHv{font-weight:700}.typography--lightText--3OxWt{font-weight:300}.typography--smallSize--3N0Zi{font-size:12px}.typography--axisSize--1AWL1{font-size:14px}.typography--largeSize--2187z{font-size:17px}.typography--defaultSize--vpvHG{font-size:14px}.typography--largeSize--2187z{font-size:16px}.typography--mediumContrastText--uXnbW{color:var(--text-medium-contrast);fill:var(--text-medium-contrast)}.typography--highContrastText--3ek29{color:var(--text-high-contrast);fill:var(--text-high-contrast)}.typography--noWrap--3endD{white-space:nowrap}.typography--svgMiddleAnchored--3FWrW{text-anchor:middle}.typography--svgRightAnchored--uk3Z8{text-anchor:end}.typography--svgStartAnchored--3vZKR{text-anchor:start}.typography--svgVerticalCentered--39MGn{dominant-baseline:central}", ""]);

// exports
exports.locals = {
	"whiteText": "typography--whiteText--2eeXA",
	"boldText": "typography--boldText--osnHv",
	"lightText": "typography--lightText--3OxWt",
	"smallSize": "typography--smallSize--3N0Zi",
	"axisSize": "typography--axisSize--1AWL1",
	"largeSize": "typography--largeSize--2187z",
	"defaultSize": "typography--defaultSize--vpvHG",
	"mediumContrastText": "typography--mediumContrastText--uXnbW",
	"highContrastText": "typography--highContrastText--3ek29",
	"noWrap": "typography--noWrap--3endD",
	"svgMiddleAnchored": "typography--svgMiddleAnchored--3FWrW",
	"svgRightAnchored": "typography--svgRightAnchored--uk3Z8",
	"svgStartAnchored": "typography--svgStartAnchored--3vZKR",
	"svgVerticalCentered": "typography--svgVerticalCentered--39MGn"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/styles/typography.css
 ** module id = 8
 ** module chunks = 0
 **/